import { render, staticRenderFns } from "./ProductListView.vue?vue&type=template&id=71e8d8a4&scoped=true"
import script from "./ProductListView.vue?vue&type=script&lang=js"
export * from "./ProductListView.vue?vue&type=script&lang=js"
import style0 from "./ProductListView.vue?vue&type=style&index=0&id=71e8d8a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e8d8a4",
  null
  
)

export default component.exports